import { render, staticRenderFns } from "./addorRecoFace2.vue?vue&type=template&id=25e80505&scoped=true"
import script from "./addorRecoFace2.vue?vue&type=script&lang=js"
export * from "./addorRecoFace2.vue?vue&type=script&lang=js"
import style0 from "./addorRecoFace2.vue?vue&type=style&index=0&id=25e80505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e80505",
  null
  
)

export default component.exports